export default {
  id: "game-admin",
  name: "Game Admin",
  shortName: "Game",
  description: "Live monitoring, config & leaderboards",
  icon: "gamepad",
  color: "#EC1E24",
  roles: ["super_admin", "admin"],
  css: "styles/apps/game-admin.css",
  nav: [
    { id: "live", label: "Live" },
    { id: "config", label: "Config" },
    { id: "analytics", label: "Analytics" },
    { id: "leaderboard", label: "Leaderboard" },
    { id: "sprites", label: "Sprites" },
    { id: "access", label: "Access" },
  ],
  defaultView: "config",
};
